import { useContext } from 'react';
import { UserContext } from '../Context/UserContextAPI';

const UseContextData = () => useContext(UserContext);

export default UseContextData;
